export default "__VITE_ASSET__BFM5l474__"